import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 公共接口
enum API {
  // 资金划账
  V1Transfer = '/hk-web/v1/transfer',
  // hotcoin优化---获取最新可更新APP版本，没有则不返回
  GetAppLatestVersion = '/hk-web/getAppLatestVersion',
  // hotcoin优化---获取公告列表
  ListArticle = '/hk-web/listArticle',
  // hotcoin优化---获取轮播图、登录弹窗等
  ListBanner = '/hk-web/listBanner',
  // 专区币种列表
  RegionCurrencyList = '/hk-web/region/currency/list',
  // 加密接口说明
  SafyInterface = '/hk-web/safyInterface',
  // 获取系统初始化参数(加密不签名)
  Gsip = '/hk-web/gsip',
  // 查询受限制的国家或地区列表
  PublicCommonLocales = '/hk-web/public/common/locales',
  // 资金划账
  V2Transfer = '/hk-web/v2/transfer',
  // 获取APP配置信息
  PublicGetAppConfig = '/hk-web/public/get-app-config',
  // 获取WEB配置信息
  PublicGetWebConfig = '/hk-web/public/get-web-config',
  // 根据币种名称查询币种详情
  PublicCurrencyDetail = '/hk-web/public/currency/detail',
}

export type TPostV1TransferParams = {}
export type TPostV1TransferResponse = TResponse<any>
export const postV1Transfer = (params?: TPostV1TransferParams) => {
  return hcAxios.post<TPostV1TransferResponse>(API.V1Transfer, params)
}

export type TGetGetAppLatestVersionParams = {
  curencyVersion?: any // curencyVersion
}
export type TGetGetAppLatestVersionResponse = TResponse<any>
export const getGetAppLatestVersion = (params?: TGetGetAppLatestVersionParams) => {
  return hcAxios.get<TGetGetAppLatestVersionResponse>(API.GetAppLatestVersion, { params })
}

export type TGetListArticleParams = {
  pageNum?: any // 页码
  pageSize?: any // 每页显示条数
}
export type TGetListArticleResponse = TResponse<
  {
    createTime?: number // 创建时间
    id?: number // id
    title?: string // 标题
    url?: string // 文章url
  }[]
>
export const getListArticle = (params?: TGetListArticleParams) => {
  return hcAxios.get<TGetListArticleResponse>(API.ListArticle, { params })
}

export type TGetListBannerParams = any
export type TGetListBannerResponse = TResponse<
  {
    id?: number // id
    imageUrl?: string // 图片url
    jumpUrl?: string // 跳转链接
    name?: string // 名称
  }[]
>
export const getListBanner = (params?: TGetListBannerParams) => {
  return hcAxios.get<TGetListBannerResponse>(API.ListBanner, { params })
}

export type TGetRegionCurrencyListParams = {
  code?: any // 专区id，1、DeFi专区 2、NFT板块 3、波卡生态板块 4、存储板块 5、Layer2专区、6元宇宙、7AI板块、8香港板块、9Cosmos板块
  pageNum?: any // 页码，默认为1
  pageSize?: any // 分页大小，默认为20
}
export type TGetRegionCurrencyListResponse = TResponse<
  {
    id?: number // 数据id
    code?: number // 专区id 1DeFi专区 2NFT板块 3波卡生态板块 4存储板块 5Layer2专区
    nameZh?: string // 币种中文名
    nameEn?: string // 币种英文名
    sellShortName?: string // 计价币
    buyShortName?: string // 标的币
    webLogo?: string // 图片url
    tagZh?: string // 币种中文标签
    tagEn?: string // 币种英文标签
    tradeId?: number // 现货交易对id，不支持是为0，表示无法跳转
    contractCode?: string // 合约交易对code，不支持是为空字符，表示无法跳转
  }[]
>
export const getRegionCurrencyList = (params?: TGetRegionCurrencyListParams) => {
  return hcAxios.get<TGetRegionCurrencyListResponse>(API.RegionCurrencyList, { params })
}

export type TGetSafyInterfaceParams = any
export type TGetSafyInterfaceResponse = TResponse<{}>
export const getSafyInterface = (params?: TGetSafyInterfaceParams) => {
  return hcAxios.get<TGetSafyInterfaceResponse>(API.SafyInterface, { params })
}

export type TPostGsipParams = {
  bizType?: string // 固定为GSIP
  timestamp?: number // 13位时间戳
}
export type TPostGsipResponse = TResponse<{
  ssk?: string // 签名秘钥(需AES解密)
}>
export const postGsip = (params?: TPostGsipParams) => {
  return hcAxios.post<TPostGsipResponse>(API.Gsip, params)
}

export type TGetPublicCommonLocalesParams = {
  scene?: any // 1-注册 2-登录 3-绑定 4-修改 5-KYC
}
export type TGetPublicCommonLocalesResponse = TResponse<string[]>
export const getPublicCommonLocales = (params?: TGetPublicCommonLocalesParams) => {
  return hcAxios.get<TGetPublicCommonLocalesResponse>(API.PublicCommonLocales, { params })
}

export type TPostV2TransferParams = any
export type TPostV2TransferResponse = TResponse<any>
export const postV2Transfer = (params?: TPostV2TransferParams) => {
  return hcAxios.post<TPostV2TransferResponse>(API.V2Transfer, params, {
    options: {
      disableErrorCodeResponseHandler: true,
    },
  })
}

export type TPostPublicGetAppConfigParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: string // 时间戳
}
export type TPostPublicGetAppConfigResponse = TResponse<{
  version?: string // 配置版本号
  region?: string // 区域，比如 hk
  signs?: string[] // 随机参数列表
  domain?: {
    officialWebsite?: string // 官网地址      */
    h5I18n?: string // h5接口国际化域名
    h5domain?: string // h5接口域名
    otc?: string // otc接口域名
    chat?: string // 聊天接口
    oss?: string // 上传接口
    klineHistory?: string // 历史k线
    securityUpload?: string // oss私密上传
    contract?: string // 合约接口域名
    stock?: string // 现货接口域名
    serviceHttp?: string // 客服聊天Http地址域名
    serviceFile?: string // 客服聊天文件地址域名
    analyticsUrl?: string // 埋点域名
    urls?: {
      domainId?: string // 域名id
      port?: number // 端口
      supportHttpDNS?: boolean // 是否支持DNS
      curDefault?: boolean // 是否当前默认
      domain?: string // 域名
    }[]
    jpushReport?: string // 极光上报
    jpushLinkHost?: string // 极光长链接
  } // Http网关域名
  wss?: {
    chatWss?: {
      path?: string // 接口路径
      urls?: {
        domainId?: string // 域名id
        port?: number // 端口
        supportHttpDNS?: boolean // 是否支持DNS
        curDefault?: boolean // 是否当前默认
        domain?: string // 域名
      }[]
    } // 聊天WebSocket推送
    stockPush?: {
      path?: string // 接口路径
      urls?: {
        domainId?: string // 域名id
        port?: number // 端口
        supportHttpDNS?: boolean // 是否支持DNS
        curDefault?: boolean // 是否当前默认
        domain?: string // 域名
      }[]
    } // 现货WebSocket推送
    contractPush?: {
      path?: string // 接口路径
      urls?: {
        domainId?: string // 域名id
        port?: number // 端口
        supportHttpDNS?: boolean // 是否支持DNS
        curDefault?: boolean // 是否当前默认
        domain?: string // 域名
      }[]
    } // 合约WebSocket推送
  } // Websocket网关域名
  bbocalculatPercent?: string // 限价委托、计划委托对手价或最优n档下买单时，计算数量的常量
  BBOCalculatPercent?: string // 限价委托、计划委托对手价或最优n档下买单时，计算数量的常量
}>
export const postPublicGetAppConfig = (params?: TPostPublicGetAppConfigParams) => {
  return hcAxios.post<TPostPublicGetAppConfigResponse>(API.PublicGetAppConfig, params)
}

export type TGetPublicGetWebConfigParams = {
  version?: any // 版本号，默认为空
  client?: any // 客户端 1-web 4-h5
}
export type TGetPublicGetWebConfigResponse = TResponse<{
  version?: string // 配置版本号
  officialWebsites?: string[] // 官方域名列表
  backupWebsites?: string[] // 备用域名列表
}>
export const getPublicGetWebConfig = (params?: TGetPublicGetWebConfigParams) => {
  return hcAxios.get<TGetPublicGetWebConfigResponse>(API.PublicGetWebConfig, { params })
}

export type TGetPublicCurrencyDetailParams = {
  coinId?: any // 币种id
  currency?: any // 币种name
  lang?: any // 当前语言
}
export type TGetPublicCurrencyDetailResponse = TResponse<{
  coinId?: number // 币种id
  currency?: string // 币种符号
  nameZh?: string // 币种中文名称
  nameEn?: string // 币种英文名称
  logo?: string // logo
  rank?: number // 排名
  marketCap?: string // 市值
  fullyDilutedMarketCap?: string // 完全稀释值
  volCapRatio?: string // 交易额/市值(24小时)
  marketCapDominance?: string // 市场占有率
  circulatingSupply?: string // 流通供应量
  maxSupply?: string // 最大供应量
  totalSupply?: string // 总供应量
  dateLaunch?: number // 发行日期
  hisHighPrice?: number // 历史最高价
  hisHighPriceTs?: number // 历史最高价时间
  hisLowPrice?: number // 历史最低价
  hisLowPriceTs?: number // 历史最低价时间
  website?: string // 官网地址
  whitePaper?: string // 白皮书
  sourceCode?: string // 源码地址，比如Github
  explorer?: string // 区块浏览器
  twitter?: string // Twitter
  reddit?: string // Reddit
  facebook?: string // Facebook，暂不支持
  telegram?: string // Telegram，暂不支持
  description?: string // 币种简介
}>
export const getPublicCurrencyDetail = (params?: TGetPublicCurrencyDetailParams) => {
  return hcAxios.get<TGetPublicCurrencyDetailResponse>(API.PublicCurrencyDetail, { params })
}
